import { PrimaryButton, PrimaryButtonOutLine } from "components/PrimaryButton";
import { t } from "i18next";

function LoyaltyModalFooter({
  onCancel,
  onConfirm,
  cancelLabel = t("loyaltyPackage.form.cancel"),
  confirmLabel = t("common.confirm"),
  loading = false,
  confirmHtmlType,
  inBody = false,
}) {
  return (
    <div className={`loyalty-modal-footer${inBody ? " loyalty-modal-footer--in-body" : ""}`}>
      <PrimaryButtonOutLine title={cancelLabel} onClick={onCancel} style={{ color: "#000", borderColor: "#d9d9d9" }} />
      <PrimaryButton
        title={confirmLabel}
        onClick={confirmHtmlType ? undefined : onConfirm}
        loading={loading}
        htmlType={confirmHtmlType}
      />
    </div>
  );
}

export default LoyaltyModalFooter;
